import { render, staticRenderFns } from "./Task.vue?vue&type=template&id=2d095fee&scoped=true&"
import script from "./task.js?vue&type=script&lang=js&"
export * from "./task.js?vue&type=script&lang=js&"
import style0 from "./Task.vue?vue&type=style&index=0&id=2d095fee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d095fee",
  null
  
)

export default component.exports